import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Alert,
} from '@mui/material';
import axios from 'axios';
import Header from '../../components/Header';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const response = await axios.post('https://api.komorotel.com/api/user/forgot-password', { email });
      setSuccessMsg(response.data.message || "Lien envoyé avec succès.");
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Une erreur s’est produite.");
    }
  };

  return (
    <>
    <Header disabled={true} />
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>
          Mot de passe oublié
        </Typography>

        <Typography variant="body2" textAlign="center" mb={3}>
          Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.
        </Typography>

        {successMsg && <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert>}
        {errorMsg && <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            required
            label="Adresse e-mail"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ py: 1.5, borderRadius: 2 }}
          >
            Envoyer le lien de réinitialisation
          </Button>
        </Box>
      </Paper>
    </Container>
    </>
  );
};

export default ForgotPassword;
